module.exports = __webpack_public_path__ + "static/content_5_2_eg-7594dde2e00dcd4bb94b25511be29a71.png";